import { render, staticRenderFns } from "./DeliverableDatesRibbon.vue?vue&type=template&id=66268956&"
import script from "./DeliverableDatesRibbon.vue?vue&type=script&lang=js&"
export * from "./DeliverableDatesRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports